module.exports = __webpack_public_path__ + "static/media/bg7.607a4a36.jpg";